import { render, staticRenderFns } from "./qualificationReview.vue?vue&type=template&id=6c8b12e6&"
import script from "./qualificationReview.vue?vue&type=script&lang=js&"
export * from "./qualificationReview.vue?vue&type=script&lang=js&"
import style0 from "./qualificationReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports